import O1HD, { modules } from "../../engines/gameEngine";
import userService from "../../engines/services/userService";
import NormalGameManager, { RegisterSpecialEventEntity, RegisterSpecialEventEntityCopy } from "./manager/NormalGameManager";
import { getkneadEventAry, getMarketEventAry, getOneNormalEventNewById, getparkEventAry } from "./config/normalEvent_NewConfig";
import data_control from "../../engines/libs/data_control";
import { PLATFORM_CODE } from "../../engines/services/ossService";
import { GAME_MODE } from "../../engines/managers/gameContent/gameMode_json";
import BackpackPrefab from "./prefab/backpack/BackpackPrefab";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "./BundleResourceConfig";
import ShopLotteryFFCManager from "./prefab/shop/lottery/ShopLotteryFFCManager";
import ShopCenterPrefab from "./prefab/shop/lottery/ShopCenterPrefab";
import { backpackOpenType } from "./config/backpackConst";
import CsvDataManage from "../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../define/CsvFileKind";
import { FileKind } from "../define/FileKind";
import utilsView from "../../engines/libs/utilsView";
import WeChatMain from "./prefab/weChat/WeChatMain";
import WeChatNewMessageNotfiy from "./prefab/weChat/WeChatNewMessageNotfiy";
import { UIKind } from "../define/UIKind";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import loanSuccessPage from "./prefab/cooperativePrefab/loanSuccessPage";
import { DelayTimeEventInfo, FixedTimeEventItem } from "./manager/DefineInterface";
import { GeneralKind } from "../define/GeneralKind";
import gameConfig from "../../engines/configs/gameConfig";
import { MessageEventKind } from "../define/MessageEventKind";
import ShakeTween2 from "../../engines/components/tweens/ShakeTween2";
import UserDataManage from "./model/UserDataManage";
import { ApiSensitiveMsg, AqSensitiveBody, AqSensitiveRes } from "../../engines/modules/httpContent/gameHttpContent";
import { xj_sdk } from "../../engines/services/miniGameContent/tt/xj.sdk";
const { ccclass, property } = cc._decorator;
@ccclass
export default class normalMode extends cc.Component {

    @property(cc.Node)
    nodeTaskRedPoint: cc.Node = null;
    @property(cc.Node)
    nodeTask: cc.Node = null;
    @property(cc.Node)
    btnArrowMenu: cc.Node = null;
    @property(cc.Node)
    sprMoveMenuBg: cc.Node = null;
    @property(cc.Node)
    nodeMoveMenu: cc.Node = null;

    @property(cc.Node)
    nodeLeftTopMoveMenu: cc.Node = null;
    @property(cc.Node)
    btnLeftTopArrowMenu: cc.Node = null;
    @property(cc.Node)
    nodeLeftSingle: cc.Node = null;
    @property(cc.Node)
    nodeLeftList: cc.Node = null;
    @property(cc.Node)
    nodeLeftTopBtnLayout: cc.Node = null;
    @property(cc.Node)
    nodeLeftTop: cc.Node = null;
    @property(cc.Node)
    btnSuperPower: cc.Node = null;
    @property(cc.Node)
    btnKongTong: cc.Node = null;
    @property(cc.Node)
    btnSkipPlot: cc.Node = null;

    @property(cc.Node)
    btnWaterCourse: cc.Node = null;
    @property(cc.Node)
    btnPalace: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnMap: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeCity: cc.Node = null;

    // @property({ type: cc.Prefab, displayName: "特殊事件预展示制体" })
    // specialEventShowPrefab: cc.Prefab = null;

    // @property({ type: cc.Prefab, displayName: "特殊事件预展示制体Copy" })
    // specialEventShowPrefabCopy: cc.Prefab = null;
    // @property({ type: cc.Prefab, displayName: "彩票事件预制体" })
    // lotteryEventShowPrefab: cc.Prefab = null;

    // @property({ type: cc.Prefab, displayName: "图文事件预展示制体" })
    // imgEventShowPrefab: cc.Prefab = null;

    // @property({ type: cc.Prefab, displayName: "告示预展示制体" })
    // noticeShowPrefab: cc.Prefab = null;

    @property(cc.Node)
    btnSkipNode: cc.Node = null;

    // @property({ type: cc.Prefab, displayName: "对话聊天预制体" })
    // dialogueEventPrefab: cc.Prefab = null;

    // @property({ type: cc.Prefab, displayName: "剧情预制体" })
    // plotPrefab: cc.Prefab = null;

    // @property({ type: cc.Prefab, displayName: "新的事件预制体" })
    // eventPrefab_New: cc.Prefab = null;

    // @property({ type: cc.Prefab, displayName: "新的消息预制体" })
    // eventChatPrefab_New: cc.Prefab = null;

    @property({ type: cc.Node, displayName: "btn节点" })
    btnNode: cc.Node = null;

    shopLotteryFFCManager: ShopLotteryFFCManager;//小卖铺彩票
    gameManager: NormalGameManager;//游戏主Manager

    // @property({ type: cc.Prefab })
    // weChat: cc.Prefab = null;

    // @property({ type: cc.Prefab, displayName: "添加桌面预制体" })
    // addDeskPage: cc.Prefab = null;

    @property({ type: cc.Node, displayName: "添加桌面" })
    btnAddDeskNode: cc.Node = null;

    @property({ type: cc.Node, displayName: "排行榜" })
    btnRankListNode: cc.Node = null;

    @property(cc.Node)
    nodeAdCard: cc.Node = null;

    // @property({type:cc.Prefab,displayName:"开始预制体"})
    // startPrefab:cc.Prefab = null;

    // @property({type:cc.Prefab,displayName:"闲置提醒预制体"})
    // idleNoticePrefab : cc.Prefab = null;

    // @property({type:cc.Label,displayName:"恋爱屋所有的钱"})
    // lbLoveHouseAllCoins : cc.Label = null;

    // @property({type:cc.Prefab,tooltip:"关注界面"})
    // attentionP:cc.Prefab = null;

    /** 微信新消息提醒节点 */
    @property(cc.Node)
    nodeWechatRemind: cc.Node = null;

    // @property(cc.Prefab)
    // weChatNewMessageNotfiy: cc.Prefab = null;

    // @property({ type: cc.Prefab, displayName: "背包预制体" })
    // backpackPrefab: cc.Prefab = null;

    /**
     * 打开工地
     */
    // onBtnSite() {
        // let siteNode = cc.instantiate( this.sitePrefab );
        // this.node.addChild( siteNode );
    // }

    //游戏模式
    static gameMode: string;

    private mSpecialShowEventArray: RegisterSpecialEventEntity[] = [];//需要展示的预制体
    /** 新消息数组 */
    private newMessageArr: string[] = [];
    /** 是否有固定时间事件未处理 */
    // private bFixedTimeEvent = false;
    // private showFixedTimeLayer = false;

    /** 是否正在打开事件 */
    private bOpenEventLayer = false;

    private bPromoteLevel = false;

    onLoad() {
        O1HD.on("normalMode.addEvent", this.addEvent, this);
        O1HD.on("normalMode.setSpecialEventShow", this.setSpecialEventShow, this);
        O1HD.on("normalMode.setImgEventShow", this.setImgEventShow, this);
        O1HD.on("normalMode.onBackNormal", this.onBackNormal, this);
        O1HD.on("normalMode.loanSuccess", this.loanSuccess, this);
        O1HD.on("normalMode.setDestokHide",this.setDestokHide,this);
        O1HD.on("normalMode.guideEnterModule",this.guideEnterModule,this);
        O1HD.on("normalMode.notifyNewChatMessage",this.notifyNewChatMessage,this);
        O1HD.on("normalMode.notifyOpenBackpack",this.openBackpack,this);

        O1HD.on("normalMode.refreshLoveStoryInfo" , this.refreshLoveStoryInfo , this );
        O1HD.on("normalMode.refreshopenWeChat" , this.openWeChatLayer , this );
        O1HD.on("normalMode.onBtnOpenPrefab" , this.onBtnOpenPrefab, this );
        O1HD.on("normalMode.openAttention" , this.openAttention, this );
        O1HD.on("normalMode.updateLieYing" , this.updateLieYing, this );
        O1HD.on(MessageEventKind.EventName.REFRESH_SPECIAL_BTN_STATE, this.refreshTopLeftBtnState, this );
        O1HD.on(MessageEventKind.EventName.PROMOTE_LEVEL, this.promoteLevel, this);
        O1HD.on(MessageEventKind.EventName.SHOW_MILITARY_MAP, this.showMilitaryMap, this);
        O1HD.on(MessageEventKind.EventName.REFRESH_TASK_STATE, this.refreshTaskState, this);
        O1HD.on(MessageEventKind.EventName.REFRESH_AD_CARD_COUNT, this.refreshAdCardCount, this);

        O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStart({ duration: 60 });
        O1HD.getServices() && O1HD.getServices().miniGameSrv.getAppApiInstance && O1HD.getServices().miniGameSrv.getAppApiInstance().screenFit();

        this.btnNode.children.forEach((n: cc.Node) => {
            if (!n.active) {
                return;
            }
            let touchArea = cc.find('touchArea', n);
            if (!touchArea) {
                return;
            }
            let polygon = touchArea.getComponent(cc.PolygonCollider);
            touchArea.on("touchstart", (e: cc.Event.EventTouch) => {
                
                let touchPos = touchArea.convertToNodeSpaceAR(e.getLocation());
                touchPos.x -= polygon.offset.x;
                touchPos.y -= polygon.offset.y;

                if (cc.Intersection.pointInPolygon(touchPos, polygon.points)) {
                    let line = n.getChildByName("line");
                    if (line) {
                        line.active = true;
                    }
                    touchArea._touchListener.setSwallowTouches(true);
                } else {
                    touchArea._touchListener.setSwallowTouches(false);
                }
            }, this);
            touchArea.on("touchend", (e: cc.Event.EventTouch) => {
                let line = n.getChildByName("line");
                if (line && line.active) {
                    this.onBtnOpenPrefab(e, n.name);
                    line.active = false;
                }
            }, this);
            touchArea.on("touchcancel", (e: cc.Event.EventTouch) => {
                let line = n.getChildByName("line");
                if (line && line.active) {
                    line.active = false;
                }
            }, this);
        });
        cc.game.on(cc.game.EVENT_SHOW, () => {
            O1HD.getManagers().soundMgr.playMusic("hallBgm");
        }, this);

        this.nodeAdCard.zIndex = cc.macro.MAX_ZINDEX;
        // getOneBundleOnePrefab(BUNDLE_SMALL_NAME.investStockGameBundle,"prefab/investStock").then((prefab:cc.Prefab)=>{
        //     if(prefab){
        //         let node:cc.Node = cc.instantiate(prefab);
        //         node.setParent(O1HD.Canvas());
        //     }
        // })

        // console.log(cc.assetManager.getBundle(BUNDLE_SMALL_NAME.WeChatGameBundle));
    }

    guideEnterModule(uiTag: string) {
        let node = this.btnNode.getChildByName(uiTag);
        if (!node) {
            console.error(`未找到模块`);
            return;
        }
        let touchLayer: cc.Node = null;
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.EmptyTouchLuckLayer
            , null 
            , null
            , UI_Z_INDEX.DIALOG
            , (touchNode)=> {
                touchLayer = touchNode;
            }
        )
        let line = node.getChildByName("line");
        line.active = true;
        cc.tween(line)
        .delay(1)
        .call(()=> {
            this.onBtnOpenPrefab(null, uiTag);
            line.active = false;
            touchLayer && touchLayer.destroy();
        })
        .start();
    }


    /**
     * 摆盘
     */
    async onBtnSwingPlateShop(){
        let url = "prefab/swingPlateShop";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.setUpShopGameBundle,url);
        let animalPrefab = cc.instantiate(prefab);
        this.node.addChild(animalPrefab);
    }

    /**
     * 添加桌面
     */
    onBtnDesk() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // let page = cc.instantiate(this.addDeskPage);
        // this.node.addChild(page);
    }

    // @property({ type: cc.Prefab, displayName: "排行榜第一的预制体" })
    // firstRankPage: cc.Prefab = null;

    async getOneRank() {
        // return new Promise<void>(resolve=>{
        //     let tt = window["tt"];
        //     if(tt){
        //         tt.getImRankData({
        //             relationType: "all",
        //             dataType: 0,
        //             rankType: "day",
        //             pageNum: 1,
        //             pageSize: 40,
        //             success(res) {
        //               console.log(`getImRankData success res: ${res}`);
        //               resolve();
        //                 // let data = res[0];
        //                 // if(data){
        //                 //     let page = cc.instantiate(this.firstRankPage);
        //                 //     let ps = page.getComponent(firstRankPage);
        //                 //     ps.bindData(data.nickName,data.user_img,data.value,resolve);
        //                 // }else{
        //                 //     resolve();
        //                 // }
        //             },
        //             fail(res) {
        //               console.log(`getImRankData fail res: ${res.errMsg}`);
        //                 resolve();
        //             },
        //           });
        //     }else{
        //         resolve();
        //     }
        // });
    }

    setDestokHide(){
        this.btnAddDeskNode.active = false;
    }

    async start() {
        let platName : string;
        let tt = window['tt'];
        if ( tt ) {
            tt.getSystemInfo({
                complete: ((res) => {
                    // console.log("res", res );
                    if (res) {
                        platName = res.appName;
                        // console.log("app名称", platName );
                        if ( window['tt'] && ( platName == "Douyin" || platName == "douyin_lite" )) {
                            // if(O1HD.getManagers().gameMgr.checkCanAddDestokAward()){
                            //     this.btnAddDeskNode.active = true;
                            // }
                        }
                    }
                })
            });

            let options = tt.getLaunchOptionsSync();
            console.log(options.showFrom);
            console.log('启动参数', options, JSON.stringify(options));
        }
        
        let ks = window['ks'];
        if(ks){
            ks.login({
                success:res=>{
                    console.log("ks登录成功，code="+res.code);
                    const params:AqSensitiveBody = {
                        checkStr: res.code
                    }
                    modules().gameHttpModule.sendMessage(ApiSensitiveMsg.head, "POST", params, (res: AqSensitiveRes) => {
                        console.log("任务请求成功", res)
                    },()=>{
                        console.error("error");
                    });
                },fail:err=>{
                    console.error("ks登录失败！",err);
                }
            });
        }

        //初始化游戏人物 值
        userService.mZodiacData = null;
        // O1HD.getServices().userSrv.reset();

        this.shopLotteryFFCManager = new ShopLotteryFFCManager(this);
        this.shopLotteryFFCManager.start();

        this.gameManager = new NormalGameManager(this);
        //判定是不是失败了
        this.gameManager.checkGameStatus();


        // this.weChat.bindManager(this.weChatManager);

        this.gameManager.triggerAutoEvent();

        //开场白预制体
        // let openingPrefab = cc.instantiate( this.dialogueEventPrefab );
        // openingPrefab.getComponent(DialogueEventShow).bindEvent()
        let bFirstGame = false;
        if (this.gameManager.getGameData().plotDialogue == false) {
            bFirstGame = true;
            this.gameManager.autoTriggerWeChatLink();
            // // 写入账本初始数据
            // let accountItem: AccountItem[] = [
            //     {
            //         uniqueId: "1",
            //         title: "彩礼费用",
            //         desc: "筹集彩礼费用，分期付款形式每日所需还款@！共计@ 总需@",
            //         paramsArray: ["2000元", "300日", "60w"],
            //         totalFee: 600000,
            //         needPayDays: 300,
            //         hasPayDays: 0,
            //     },
            // ]
            // this.gameManager.setGameData({ userAccountInfo: accountItem }, true);
            // this.gameManager.setGameData({ userAccountInfoNewMsg: 1 }, false);
            // this.gameManager.setGameData({ plotDialogue: true }, false);

            this.openStartPage();
        } else {
            this.gameManager.spliceOneNodeStrs(null);
            if(NormalGameManager._instance.getGameData().isFirstOutSize){
                utilsView.openPopupLayerTwo(FileKind.PrefabFilePath.outSizePage);
            }
        }

        // if ( normalMode.gameMode == "start" ){
        //     this.gameManager.resetManager();
        //     O1HD.getServices().localStorageSrv.setStorage( "spend-mode-data-save-key" ,"");
        //     let node = cc.instantiate(this.plotPrefab);
        //     node.getComponent( PlotPage ).bindData( this );
        //     node.setParent(this.node);
        // }else{
        O1HD.getManagers().soundMgr.playMusic("hallBgm");
        // }

        // let site = cc.instantiate( this.sitePrefab );
        // this.node.addChild( site );
        // if(this.canShowFlag && this.gameManager.getGameData().eventQueue.length > 0){
        //     this.openOneNewEvent();
        //     this.canShowFlag = false;
        // }
        let stockPriceArray = this.gameManager.getGameData().stockPriceArray
        if (this.gameManager.getCurrentDay() == 0 && stockPriceArray.length == 0) {
            this.gameManager.onStockPriceChange()
        }
        // 预加载 所有bundle内容
        this.preloadAllBundleResource();

        this.gameManager.loginSuccess();

        let params = { uid : null , code : null , anonymousCode : null };
        // this.login();

        if(isNaN(O1HD.getServices().userSrv.getCoins())){
            O1HD.getModules().uiControlModule.showDialogBox("补偿公告","由于游戏出现bug导致玩家钱丢失，特此向丢失钱的玩家补偿100万",false);
            O1HD.getServices().userSrv.setCoins(1000000,false);
        }

        this.refreshLoveStoryInfo();
        this.updateSpecialState();

        this.refreshTaskState();
		this.updateLieYing();

        this.refreshAdCardCount();
        this.refreshTopLeftBtnState();

        if (!bFirstGame) {
            // this.gameManager.openCompensateAwardLayer();
        }

        // NormalGameManager._instance.addOneWeChatTriggerLink("45")

        // this.gameManager.spliceOneNodeStrs(null);

        // let accountItem : AccountItem[] = [
        //     {
        //         uniqueId:`${NormalGameManager._instance.getGameData().userAccountInfo.length+1}`,
        //         title : "贷款还款",
        //         desc : "成功贷款@！日利率@ \n限期@还清，每日还款@",
        //         paramsArray:["50000元","5%","10日","5250"],
        //         totalFee : 52500,
        //         needPayDays : 10,
        //         hasPayDays : 0,
        //     },
        // ];
        // NormalGameManager._instance.setGameData( { userAccountInfo:accountItem },true );
        // NormalGameManager._instance.setGameData( { userAccountInfoNewMsg : 1 },false );
    }

    @property({type:cc.Node,tooltip:"猎鹰节点"})
    lieYingNode:cc.Node = null;
    updateLieYing(){
        this.lieYingNode.active = (NormalGameManager._instance.getOneGood(50022) != null);
    }

    /**
     * 刷新
     */
    refreshLoveStoryInfo () {
        // let totalCoin = NormalGameManager._instance.loveStroyManager.getAllCoins();
        // this.lbLoveHouseAllCoins.string = `${data_control.getNumberFormat(totalCoin)}`;
    }

    openStartPage() {
        utilsView.openPopupLayer(
            'prefab/page/startPage'
            , BUNDLE_SMALL_NAME.normalMode
        )
        // let page = cc.instantiate(this.startPrefab);
        // page.setParent(O1HD.Canvas());
    }

    /**
     * 预加载所有bundle资源
     */
    async preloadAllBundleResource(){
        // let bundleName : string = "animalMode";
        // let bundle = cc.assetManager.getBundle( bundleName );
        // if ( !bundle ) {
        //     await new Promise(resolve=>{
        //             cc.assetManager.loadBundle( `animalMode` ,( err , tempBundle )=>{
        //                 if ( err ) {
        //                     console.log("加载bundle出错");
        //                     return
        //                 }
        //                 //加载成功
        //                 bundle = tempBundle;
        //                 resolve();
        //             });
        //         }
        //     )
        // }
        // //
        // bundle.load(``);
        // // cc.resources.preload(``,)

    }


    /**
     * 贷款成功
     * @param desc
     * @param paramsArray
     */
    async loanSuccess(desc: string, paramsArray: string[]) {
        // 打开对应的提示框
        // O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`prefab/page/losePage`, cc.Prefab, (err, asset: cc.Prefab) => {
        //     if (err) {
        //         return;
        //     }
        //     let node: cc.Node = cc.instantiate(asset);
        //     let ns = node.getComponent(winPage);
        //     node.group = "UI";
        //     ns.bindLayer(this);
        //     ns.loanSuccess(desc, paramsArray);
        //     O1HD.Canvas().addChild(node);
        // });
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.cooperativeGameBundle,`cooperativeGame/loanSuccessPage`);
        if(prefab){
            let loanNode:cc.Node = cc.instantiate(prefab);
            loanNode.getComponent(loanSuccessPage).bindData(paramsArray[0],paramsArray[1],paramsArray[2],paramsArray[3]);
            O1HD.Canvas().addChild(loanNode, 10);
        }
    }

    /**
     * 跳天
     */
    onBtnSkipDayTest() {
        if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
            this.gameManager.setGameHours(24 * 60, true);
        }
    }
    
    /**
     * 断案玩法
     */
    onClickLegalCase() {
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.GOVERNMENT);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.SettlLawSuitModelSelectLayer
        );
    }

    /**
     * 府邸
     */
    onClickMansion() {
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.MansionLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MansionLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    /**
     * 比武相亲
     */
    openMatchMiaiLayer() {
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.MATCH_MIAI);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MatchMiaiLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    /**
     * 募兵界面
     */
    onClickRecruit() {
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.MilitaryRecruitOfficerLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MilitaryRecruitOfficerLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    /**
     * 城池地图
     */
    onClickMilitaryMap() {
        this.btnMap.active = false;
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.MilitaryMapLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MilitaryMapLayer
            , this.nodeCity
            , {
                parent: this
            }
            , null
            , null
            , false
        );
    }

    /**
     * 皇宫
     */
    onClickPalaceLayer() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.PalaceLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.PalaceLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    /**
     * 超级权限
     */
    onClickSuperPowerLayer() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.SuperPowerCompoundLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.SuperPowerCompoundLayer
            , null
            , null
            , UI_Z_INDEX.DIALOG
            , null
            , false
        );
    }

    /**
     * 崆峒镜
     */
    onClickKongTongLayer() { 
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.ThruTimeAccessLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.ThruTimeAccessLayer
            , null
            , null
            , UI_Z_INDEX.DIALOG
            , null
            , false
        );
    }

    /**
     * 跳过剧情
     */
    onClickSkipPlot() { 
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.SkipPlotSelectLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.SkipPlotSelectLayer
            , null
            , null
            , UI_Z_INDEX.DIALOG
            , null
            , false
        );
    }

    onBtnWaterCourse(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.WaterCourse);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.WaterCourseLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    /**
     * 添加金币
     */
    onBtnAddCoinsTest() {
        if (O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5) {
            O1HD.getServices().userSrv.setCoins(1000000, true);
        }
    }

    /**
     * 重新开始
     */
    onRestartGame() {
        this.gameManager.resetManager();
        O1HD.getManagers().gameMgr.selectMode(GAME_MODE.NORMAL).then();
    }

    onBtnExit() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.OnClear();
        O1HD.getManagers().gameMgr.returnMainScene().then();
    }

    /**
     * 打开排行榜
     */
    async onBtnOpenRank(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let url = "rankNode";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.rankGameBundle,url);
        let mineLandPrefab = cc.instantiate(prefab);
        this.node.addChild( mineLandPrefab );
    }

    onClickTask() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.TaskLayer);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.TaskLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    refreshTopLeftBtnState() {
        this.nodeLeftTop.active = true;
        let gameData = this.gameManager.getGameData();

        let bShowSkipPlot = !gameData.bSkipPlot && gameConfig.OPEN_SKIP_PLOT;
        let btnStateList = [gameData.bShowKongTongBtn, bShowSkipPlot, gameData.bShowSuperPowerBtn];
        let btnBtnList = [this.btnKongTong, this.btnSkipPlot, this.btnSuperPower];

        if (gameData.bShowKongTongBtn) {
            let thruTimeData = UserDataManage.instance.thruTimeDataManage.thruTimeData;
            let curVersion = thruTimeData.curVersion;
            let shake = this.btnKongTong.getChildByName('btnKongTong').getComponent(ShakeTween2);
            let redPoint = shake.node.getChildByName('redPoint');
            if (GeneralKind.GeneralValue.CUR_THRUN_VERSION != curVersion) {
                shake.play();
                redPoint.active = true;
            } else {
                shake.stop();
                redPoint.active = false;
            }
        }

        let bShowSingle = false;
        let bShowList = false;
        let total = 0;
        let btnShowList: cc.Node[] = [];
        for (let i = 0; i < btnStateList.length; i++) {
            if (btnStateList[i]) {
                btnBtnList[i].active = true;
                btnShowList.push(btnBtnList[i]);
                total++;
            } else {
                btnBtnList[i].active = false;
            }
        }
        if (total == 1) {
            bShowSingle = true;
        } else if (total > 1) {
            bShowList = true;
        }

        if (bShowSingle) {
            let nodeItem = btnShowList[0];
            if (nodeItem && nodeItem.parent != this.nodeLeftSingle) {
                nodeItem.parent = this.nodeLeftSingle;
                nodeItem.x = 0;
                nodeItem.y = 0;
            }
        } else {
            for (let i = 0; i < btnShowList.length; i++) {
                let nodeItem = btnShowList[i];
                if (nodeItem && nodeItem.parent != this.nodeLeftTopBtnLayout) {
                    nodeItem.parent = this.nodeLeftTopBtnLayout;
                    nodeItem.y = 0;
                }
                nodeItem.setSiblingIndex(i);
                let si = nodeItem.getSiblingIndex()
            }
        }

        this.nodeLeftSingle.active = bShowSingle;
        this.nodeLeftList.active = bShowList;

        
        if (this.btnLeftTopArrowMenu.scaleX == -1) {
            let eNodePosX = 354.5;
            if (btnShowList.length == 3) {
                eNodePosX = 476.2;
            }
            this.nodeLeftTopMoveMenu.x = eNodePosX;
        } 
    }

    onClickLeftTopMenuArrow() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.nodeLeftTopMoveMenu.stopAllActions();

        let showLen = this.nodeLeftTopBtnLayout.children.filter((v)=> {
            return v.active;
        }).length;


        let eNodePosX = 354.5;
        if (showLen == 3) {
            eNodePosX = 476.2;
        }
        if (this.btnLeftTopArrowMenu.scaleX == -1) {
            // 缩小隐藏
            this.btnLeftTopArrowMenu.scaleX = 1;
            eNodePosX = 189.359;
        } else {
            this.btnLeftTopArrowMenu.scaleX = -1;
        }

        let mt = 0.15;
        cc.tween(this.nodeLeftTopMoveMenu)
        .to(mt, {x: eNodePosX}, {easing: 'sineIn'})
        .start();
    }

    onClickMenuArrow() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        this.sprMoveMenuBg.stopAllActions();
        this.nodeMoveMenu.stopAllActions();

        let eNodePosX = 0;
        let eWidth = 600;
        if (this.btnArrowMenu.scaleX == 1) {
            this.btnArrowMenu.scaleX = -1;
            eNodePosX = 413.9;
            eWidth = 181;
        } else {
            this.btnArrowMenu.scaleX = 1;
        }

        let mt = 0.15;

        cc.tween(this.nodeMoveMenu)
        .to(mt, {x: eNodePosX}, {easing: 'sineIn'})
        .start();
        cc.tween(this.sprMoveMenuBg)
        .to(mt, {width: eWidth}, {easing: 'sineIn'})
        .start();
    }

    notifyNewChatMessage(peopleId: string) {
        if (!this.gameManager || this.newMessageArr.includes(peopleId)) {
            return;
        }
        this.newMessageArr.push(peopleId);
        let nodeStr = this.gameManager.getNodeStr();
        if (nodeStr.length < 1) {
            this.showNewChatRemind();
        }
    }

    showNewChatRemind() {
        if (this.newMessageArr.length <= 0) {
            return;
        }
        
        let peopleId = this.newMessageArr.shift();
        let people = NormalGameManager._instance.weChatManager.getOnePeopleById(peopleId);
        if(!people){
            return;
        }
        if (people.peopleChatLinkQueue.length <= 0) {
            return;
        }

        utilsView.openPopupLayer(
            'weChat/prefab/WeChatNewMessageNotfiy'
            , BUNDLE_SMALL_NAME.WeChatGameBundle
            , this.nodeWechatRemind
            , null
            , null
            , (node)=> {
                let script = node.getComponent(WeChatNewMessageNotfiy);
                script.setCarryData({
                    peopleId: peopleId
                });
            }
        );
        // let node = cc.instantiate(this.weChatNewMessageNotfiy);
        // let script = node.getComponent(WeChatNewMessageNotfiy);
        // script.setCarryData({
        //     peopleId: peopleId
        // });
        // this.nodeWechatRemind.addChild(node);
    }

    /**
     * 打开预制体
     * @param e
     * @param channel
     */
    async onBtnOpenPrefab(e, channel) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (O1HD.getServices().userSrv.getGameFail() == 1) {
            //游戏失败后，直接返回
            return;
        }

        
        if (this.gameManager.getNodeStr().includes(channel)) {
            console.error(`已存在此窗口，属于重复打开`);
            return;
        }
        
        let UILayerTag = UIKind.UILayerTag;
        switch (channel) {
            case UILayerTag.KD: {
                //矿地
                let url = "prefab/mineLandSelectPage";
                let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.mineLandGameBundle,url);
                let mineLandPrefab = cc.instantiate(prefab);
                this.node.addChild( mineLandPrefab );
                this.gameManager.addOneNodeStrs(channel);
                break;
            }
            case UILayerTag.XH: {
                // 驿站
                // this.openLakeLayer();
                this.openCooperativePage();
                // O1HD.getManagers().soundMgr.stopMusic();
                break;
            }
            case UILayerTag.WE_CHAT: {
                this.openWeChatLayer();
                break;
            }
            case UILayerTag.EXAM: {
                // this.openExam();
                this.onClickRecruit();
                break;
            }
            case "phone": {
                let url = "prefab/phonePrefab";
                let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.phoneGameBundle,url);
                let phonePrefab = cc.instantiate(prefab);
                O1HD.Canvas().addChild( phonePrefab );
                this.gameManager.addOneNodeStrs("phone");
                O1HD.getManagers().soundMgr.stopMusic();
                break;
            }
            case UILayerTag.BLM: {
                // 百乐门
                this.openShopLayer();
                return;
            }
            case UILayerTag.JOB: {
                //菜地
                this.openFarmLayer();
                break;
            }
            case "backpack": {
                this.openBackpack();
                break;
            }
            case UILayerTag.PAWN:{
                this.openPawnLayer();
                break;
            }
            case UILayerTag.GOVERNMENT:{
                // 衙门
                this.onClickMansion();
                // this.openExamLayer();
                break;
            }
            case "loveHouse":{
                this.openBillRecordLayer();
                break;
            }
            case UILayerTag.BAZZAR:{
                this.openOreGameLayer();
                // O1HD.getModules().uiControlModule.showMessageBox("暂未开放");
                break;
            }
            case UILayerTag.MATCH_MIAI:{
                this.openMatchMiaiLayer();
                break;
            }
        }
    }

    async openBackpack() {
        this.gameManager.addOneNodeStrs("backpack");
        let url = "backpack/backpackPrefab";
        O1HD.getModules().uiControlModule.showLoading();
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url, false);
        if(prefab){
            let backpack = cc.instantiate(prefab);
            backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.normal,null)
            cc.Canvas.instance.node.addChild(backpack);
        }
    }

    openExam() {
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.EXAM);
        O1HD.getModules().uiControlModule.showLoading();
        // cc.log('考场');
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.ExamLayer
            , null
            , {}
        );
    }

    /**
     * 池子
     */
    async openLakeLayer() {
        let url = "prefab/lakeNode";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.lakeGameBundle,url);
        let animalPrefab = cc.instantiate(prefab);
        this.node.addChild(animalPrefab);
        this.gameManager.addOneNodeStrs("xh");
    }

    /**
     * 菜地
     */
    async openFarmLayer() {

        let url = "sitePrefab";
        this.gameManager.addOneNodeStrs(UIKind.UILayerTag.JOB);
        O1HD.getModules().uiControlModule.showLoading();
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.siteGameBundle,url, false);
        let sitePrefabNode = cc.instantiate( prefab );
        O1HD.Canvas().addChild( sitePrefabNode );

        // let url = "prefab/farmNode";
        // let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.farmGameBundle,url);
        // let farmPrefabNode = cc.instantiate( prefab );
        // O1HD.Canvas().addChild( farmPrefabNode );
    }

    /**
     * 小卖部
     */
    async openShopLayer() {
        this.gameManager.addOneNodeStrs(UIKind.UILayerTag.BLM);
        let url = "prefab/shopPrefab";
        O1HD.getModules().uiControlModule.showLoading();
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.shopGameBundle,url, false);
        let shopPrefabNode = cc.instantiate( prefab );
        shopPrefabNode.getComponent( ShopCenterPrefab ).bindData( this.shopLotteryFFCManager );
        O1HD.Canvas().addChild( shopPrefabNode );
    }

    /**
     * 聊天界面
     */
    async openWeChatLayer() {
        // let url = "weChat/prefab/weChatHousePrefab";
        this.gameManager.addOneNodeStrs(UIKind.UILayerTag.WE_CHAT);
        let url = "weChat/prefab/weChatMain";
        O1HD.getModules().uiControlModule.showLoading();
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.WeChatGameBundle,url, false);
        let weChatHousePrefab = cc.instantiate(prefab);
        // weChatHousePrefab.getComponent(WeChatHousePrefab).bindData();
        weChatHousePrefab.getComponent(WeChatMain).bindData();
        O1HD.Canvas().addChild( weChatHousePrefab );
        O1HD.getManagers().soundMgr.stopMusic();
    }

    /**
     * 典当
     */
    async openPawnShop() {
        this.gameManager.addOneNodeStrs(UIKind.UILayerTag.PAWN);
        let url = "prefab/pawnShopStartPage";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.pawnShopGameBundle,url);
        if(prefab){
            let marketPrefabNode = cc.instantiate( prefab );
            this.node.addChild( marketPrefabNode );
        }else{
            console.error("加载集市分包出错");
            O1HD.getModules().uiControlModule.showMessageBox("加载失败~请重启游戏或者换台设备试试");
        }
    }

    async openOreGameLayer() {
        this.gameManager.addOneNodeStrs(UIKind.UILayerTag.BAZZAR);
        let url = "marketPrefab/marketPrefab";
        O1HD.getModules().uiControlModule.showLoading();
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.marketGameBundle,url, false);
        if(prefab){
            let nodeLayer = cc.instantiate( prefab );
            this.node.addChild( nodeLayer );
        }
    }

    openPawnLayer() {
        O1HD.getModules().uiControlModule.showLoading();
        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.PAWN);
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.PawnLayer
            , null
            , null
            , null
            , null
            , false
        );
    }

    /**
     * 打开恋爱屋界面
     */
    async openBillRecordLayer() {
        //恋爱屋
        let url = "prefab/billRecordPrefab";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.loveStroyGameBundle,url);
        if(prefab){
            let billRecordPrefab = cc.instantiate(prefab);
            billRecordPrefab.setParent(O1HD.Canvas());
        }else{
            console.error("加载爱情屋分包出错");
            O1HD.getModules().uiControlModule.showMessageBox("加载失败~请重启游戏或者换台设备试试");
        }
        this.gameManager.addOneNodeStrs("loveHouse");
    }

    /**
     * 打开合作社
     */
    async openCooperativePage() {
        // let url = "cooperativeGame/cooperativePage";
        // let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.cooperativeGameBundle,url);
        // if(prefab){
        //     let cooperativeNode = cc.instantiate(prefab);
        //     cooperativeNode.setParent(O1HD.Canvas());
        // }else{
        //     console.error("加载集市分包出错");
        //     O1HD.getModules().uiControlModule.showMessageBox("加载失败~请重启游戏或者换台设备试试");
        // }
        this.gameManager.addOneNodeStrs(UIKind.UILayerTag.XH);
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showLoading();
        getOneBundleOnePrefab(
            BUNDLE_SMALL_NAME.investStockGameBundle
            ,"prefab/investStockStartPage"
            , false
        ).then((prefab:cc.Prefab)=>{
            if(prefab){
                let node:cc.Node = cc.instantiate(prefab);
                node.setParent(O1HD.Canvas());
            }
        });
    }

    /**
     * 跳过当天
     */
    onBtnSkipDay() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (!this.canShowFlag) {
            O1HD.getModules().uiControlModule.showMessageBox("请等事件完结");
            return;
        }
        if (this.gameManager.getIsFirstJumpDay() ) {
            this.gameManager.setFirstJumpDay(false);
            O1HD.getModules().uiControlModule.showDialogBox("提示", "直接跳过当天，会根据跳过的时间以及连续工作(无休息)的时间，综合影响你的体力，心情和健康值。当健康值为0时，挑战即判定失败", false, (isOk: boolean) => {
                if (isOk) {
                    this.gameManager.daySettlement(true);
                }
            }, this.node);
            return;
        }
        this.gameManager.daySettlement(true);
    }

    /**
     * 清除
     * @constructor
     */
    OnClear() {

    }

    /**
     * 添加事件
     * @param delayHour 延迟触发小时
     * @param eventDesc 事件描述
     * @param effectParams 影响事件
     */
    addEvent(delayHour: number, eventDesc: string, effectParams: { key: number, value: number }[], lotteryFlag: boolean = false) {
        let specialEventEntity: RegisterSpecialEventEntity = {
            startHours: this.gameManager.mGameHours,
            waitHours: delayHour,
            type: lotteryFlag ? 4 : null,
            desc: eventDesc,
            effectParams: effectParams
        };
        this.gameManager.addSpecialEvent(specialEventEntity);
    }

    canShowFlag: boolean = true;

    /**
     * 设置要展示的 特殊事件
     * @param specialEventArray
     */
    setSpecialEventShow(specialEventArray: RegisterSpecialEventEntity[], showFlag: boolean = true) {
        this.mSpecialShowEventArray = this.mSpecialShowEventArray.concat(specialEventArray);
        if (showFlag) {
            // if ( this.canShowFlag ) {
            //     this.canShowFlag = false;
            this.specialEventShow();
            // }
        }
    }

    /**
     * 事件显示
     * @param specialEventArray
     */
    setEventShow(specialEventEntity: RegisterSpecialEventEntity) {
        // let specialShowPrefabNode = cc.instantiate(this.specialEventShowPrefab);
        // this.node.addChild(specialShowPrefabNode);
        // specialShowPrefabNode.getComponent(SpecialEventShow).bindData(specialEventEntity, this);
    }

    /**
     * 设置通知预制体
     * @param specialEventEntity
     */
    setNoticeEventShow(specialEventEntity: RegisterSpecialEventEntity) {
        //告示提示
        // let noticeShowPrefabNode = cc.instantiate(this.noticeShowPrefab);
        // this.node.addChild(noticeShowPrefabNode);
        // noticeShowPrefabNode.getComponent(NoticeEventShow).bindData(specialEventEntity.desc, specialEventEntity.effectParams, this);
    }

    /**
     * 图文事件显示
     * @param specialEventArray
     */
    setImgEventShow(specialEventEntity: RegisterSpecialEventEntity) {
        // let imgShowPrefabNode = cc.instantiate(this.imgEventShowPrefab);
        // this.node.addChild(imgShowPrefabNode);
        // imgShowPrefabNode.getComponent(ImgEventShow).bindData(specialEventEntity, this);
    }

    /**
     * 特殊事件展示
     */
    specialEventShow() {
        // if ( this.mSpecialShowEventArray.length == 0 ) {
        //     this.canShowFlag = true;
        //     return;
        // } '
        if (this.mSpecialShowEventArray.length == 0) {
            return;
        }
        let specialEventEntity = this.mSpecialShowEventArray.pop();

        // console.log(this.mSpecialShowEventArray.length);
        // let specialEventEntity;
        // for ( let i = 0 ; i < this.mSpecialShowEventArray.length ; i ++ ) {
        //     specialEventEntity = this.mSpecialShowEventArray.pop();
        //     console.log( specialEventEntity );
        //     if ( specialEventEntity.type && specialEventEntity.type == 4 ) {
        //         break;
        //     }
        // }
        // console.log(`specialEventEntity.type`,specialEventEntity.type);

        if (!specialEventEntity.type) {
            //基础事件
            // let specialShowPrefabNode = cc.instantiate(this.specialEventShowPrefab);
            // this.node.addChild(specialShowPrefabNode);
            // specialShowPrefabNode.getComponent(SpecialEventShow).bindData(specialEventEntity, this);
        } else if (specialEventEntity.type == 1) {
            //告示提示
            // let noticeShowPrefabNode = cc.instantiate(this.noticeShowPrefab);
            // this.node.addChild(noticeShowPrefabNode);
            // noticeShowPrefabNode.getComponent(NoticeEventShow).bindData(specialEventEntity.desc, specialEventEntity.effectParams, this);
        } else if (specialEventEntity.type == 2) {
            // let specialShowPrefabNode = cc.instantiate(this.specialEventShowPrefabCopy);
            // this.node.addChild(specialShowPrefabNode);
            // specialShowPrefabNode.getComponent(SpeciaEventShow_Copy).bindData((specialEventEntity) as RegisterSpecialEventEntityCopy, this);
        } else if (specialEventEntity.type == 4) {
            //彩票的 幸运大乐透 彩蛋
            // let lotteryShowPrefabNode = cc.instantiate(this.lotteryEventShowPrefab);
            // this.node.addChild(lotteryShowPrefabNode);
            // lotteryShowPrefabNode.getComponent(LotteryEventShow).bindData(specialEventEntity, this);
        }
    }

    /**
     * 从其他页面返回normal
     */
    onBackNormal(type: string) {
        this.gameManager.spliceOneNodeStrs(type);
        let nodeStrList = this.gameManager.getNodeStr();
        if (nodeStrList.length < 1) {
            this.showNewChatRemind();
            this.openEvent();
            this.btnMap.active = true;
            this.promoteLevelAni();
        }
        let gameData = this.gameManager.getGameData();
        if (gameData.todayEvent.length > 0) {
            // 今日已经触发过事件了  不再触发新事件

        } else {
            let ariseEvents: string[] = gameData.ariseEvent;
            let events: string[] = [];
            switch (type) {
                //从人才市场出来
                case "Market": {
                    events = getMarketEventAry().concat();
                    break;
                }
                //从洗浴中心出来
                case "Knead": {
                    events = getkneadEventAry();
                    break;
                }
                case "WeChat": {
                    // 从微信聊天中返回
                    // O1HD.getManagers().soundMgr.playMusic("hallBgm");
                    break;
                }
                case UIKind.UILayerTag.EnterLayerEventShow:{

                    break;
                }
                default:{
                    O1HD.getManagers().soundMgr.playMusic("hallBgm");
                    break;
                }
            }

            let notAriseEvents: string[] = [];

            if (events.length > 0) {
                for (let i = 0; i < events.length; i++) {
                    let eid = events[i];
                    if (!ariseEvents.includes(eid)) {
                        notAriseEvents.push(eid);
                    }
                }
                if (notAriseEvents.length > 0) {
                    let id = data_control.getRandItemOfArray(notAriseEvents);
                    let event = getOneNormalEventNewById(id);
                    if (event.isOnly) {
                        gameData.todayEvent.push(id);
                    }
                    this.gameManager.addOneEvent(id);
                    this.gameManager.writeGameData();
                }
            }


        }

        if (this.canShowFlag && this.gameManager.getNodeStr().length < 1) {
            this.gameManager.openOneNewEvent();
        }
        let user = O1HD.getModules().gameHttpModule.user;
        let coin = O1HD.getServices().userSrv.getCoins();
        let d = data_control.getWriteCoins(coin);
        if(O1HD.getServices().ossSrv.getPlatform() == PLATFORM_CODE.H5){
            d.formats = 0;
            d.num =0;
        }
        // O1HD.getModules().gameHttpModule.updateUserInfo({uid:user.getUserDate()._uid,gameScoreType:d.formats,gameMaxScore:d.num});
        if(window['tt']){
            let is:boolean = false;
            window["tt"].checkFollowAwemeState({
                success(res) {
                  console.log("调用成功", res);
                    if(!res.hasFollowed){
                        O1HD.emit("normalMode.openAttention");
                    }
                },
                fail(res) {
                  console.log("调用失败", res);
                },
            });

        }

        if (this.gameManager.getNodeStr().length < 1) {
            if (!gameData.bFinishHitRobEvent && gameData.bOpenHitRobEvent && gameData.bFinishBoastGuiFei) {
                
                utilsView.openEventLayer(
                    null
                    , {
                        id: '29'
                        , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                        , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                        , saveData: ()=> {
                            gameData.bFinishHitRobEvent = true;
                            this.gameManager.writeGameData();
                        }
                        , exitLayer: ()=> {
                            
                        }
                    }
                    , UI_Z_INDEX.DIALOG
                );
            } else if (gameData.bFinishHelpWife && !gameData.ariseLinks.includes('52') && !gameData.bSkipPlot) {
                utilsView.openEventLayer(
                    null
                    , {
                        id: '30'
                        , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                        , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                        , saveData: ()=> {
                            gameData.bFinishHitRobEvent = true;
                            this.gameManager.writeGameData();
                        }
                        , exitLayer: ()=> {
                            
                        }
                    }
                    , UI_Z_INDEX.DIALOG
                );
            }
        }

    }

    isHaveChat(people: string, chatsId: string, chatId: string) {
        let peopleId = NormalGameManager._instance.weChatManager.getOnePeopleById(people);
        let chats = peopleId?.peopleChatLastLink;
        return chats?.find((item)=>{
            return item.chatsId == chatsId && item.chatId == chatId;
        });
    }

    updateSpecialState() {
        // 开启44
        let normalManage = NormalGameManager._instance;
        let gameData = normalManage.getGameData();
        let b5034Finish = gameData.wechatRecordPoint.includes('5034Finish');
        let b5033Finish = gameData.wechatRecordPoint.includes('5033Finish');

        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
        let bSave = false;
        if (gameData.liBaiGoodValue >= 100 && !b5034Finish) {
            if (this.isHaveChat('华贵妃', '5032', '5')) {
                normalManage.addOneWeChatTriggerLink("45");
            }
        }
        
        if (b5034Finish && !gameData.ariseLinks.includes('46')) {
            normalManage.addOneWeChatTriggerLink("46");
        }
        
        if (!gameData.firstPassDartFlag && !gameData.ariseLinks.includes('47') && !gameData.bSkipPlot) {
            normalManage.addOneWeChatTriggerLink("47");
        }

        if (gameData.bFirstFinishYabiao1 && !gameData.ariseLinks.includes('50') && !gameData.bSkipPlot) {
            normalManage.addOneWeChatTriggerLink("50");
        }

        if (b5033Finish && !gameData.bOpenHitRobEvent && matchMiaiData.bBridePrice) {
            let bRobPay = false;
            for (let o of gameData.userAccountInfo) {
                if (o.title == '赎金') {
                    bRobPay = true;
                    break;
                }
            }
            if (!bRobPay) {
                for (let o of gameData.delayTimeEventList) {
                    if (o.id == '16') {
                        bRobPay = true;
                        break;
                    }
                }
                if (!bRobPay) {
                    gameData.bOpenHitRobEvent = true;
                    bSave = true;
                }
            }
        }

        normalManage.pawnBossMarryDataDispose();

        if (bSave) {
            normalManage.writeGameData();
        }

        UserDataManage.instance.mansionDataManage.dataCompatibility();
    }

    openAttention(){
        if(Date.now() - O1HD.getServices().userSrv.lastOpenTime > gameConfig.ATTENTION_TIME*60*1000 && (O1HD.getManagers().gameMgr.platName == "DouYin" || "douyin_lite")){
            utilsView.openPopupLayer(
                'prefab/attentionPage'
                , BUNDLE_SMALL_NAME.normalMode
            )
            // let pNode:cc.Node = cc.instantiate(this.attentionP);
            // pNode.setParent(O1HD.getModules().uiControlModule.getUIRoot());
            O1HD.getServices().userSrv.lastOpenTime = Date.now();
        }
    }

    update(dt) {

    }

    async onBtnRank() {
        let url:string = "rankNode";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.rankGameBundle,url);
        if(prefab){
            let node:cc.Node = cc.instantiate(prefab);
            node.setParent(O1HD.Canvas());
            this.gameManager.addOneNodeStrs("rankNode");
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("加载失败~请重启游戏或者换台设备试试");
        }
    }

    openPlot() {
        // let node: cc.Node = cc.instantiate(this.plotPrefab);
        // O1HD.Canvas().addChild(node);
    }

    async login(){
        let platform:PLATFORM_CODE = O1HD.getServices().ossSrv.getPlatform();
        switch(platform){
            case PLATFORM_CODE.TT:{
                await O1HD.getModules().gameHttpModule.ttLogin();
                break;
            }
        }
    }

    getCurTime() {
        let curHour = this.gameManager.mGameHours;
        let curMinute = this.gameManager.getCurMinute();
        let curTime = Math.floor((curHour * 60 + curMinute) 
            / GeneralKind.GeneralValue.GAME_TIME_JUMP);
        return curTime;
    }

    promoteLevel() {
        this.bPromoteLevel = true;
        let nodeStrList = this.gameManager.getNodeStr();
        if (nodeStrList.length < 1) {
            this.promoteLevelAni();
        }
    }

    showMilitaryMap(bshow: boolean) {
        this.btnWaterCourse.active = !bshow;
        this.btnPalace.active = !bshow;
        this.nodeLeftTop.active = !bshow;
    }

    refreshAdCardCount() {
        let goodsData = NormalGameManager._instance.getOneGood(GeneralKind.PropId.AD_CARD);
        if (goodsData && goodsData.num > 0) {
            this.nodeAdCard.active = true;
            let labelAdCardCount = this.nodeAdCard.getChildByName('labelAdCardCount').getComponent(cc.Label);
            labelAdCardCount.string = '×' + goodsData.num;
        } else {
            this.nodeAdCard.active = false;
        }
    }

    refreshTaskState() {
        let gameData = NormalGameManager._instance.getGameData();
        let bShow = gameData.bNewTask || gameData.bNewFinshTask;
        this.nodeTaskRedPoint.active = bShow;

        let shake = this.nodeTask.getComponent(ShakeTween2);
        if (bShow) {
            shake.play();
        } else {
            shake.stop();
        }
    }

    promoteLevelAni() {
        if (!this.bPromoteLevel) {
            return;
        }
        this.bPromoteLevel = false;
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.ExamSuccessLayer
            , null
            , {}
        );
    }

    /** 触发固定时间事件 */
    triggerFixedTimeEvent() {
        if (!this.gameManager) {
            return;
        }
        if (this.gameManager.getNodeStr().length >= 1) {
            return;
        }
        let gameData = this.gameManager.getGameData();
        // let currentDay = this.gameManager.getCurrentDay();
        let curTime = this.getCurTime();
        let csvName = CsvFileKind.CsvFile.FIXED_TIME_EVENT_ARR;
        let csvInfos = CsvDataManage.instance.getCsvData(csvName);
        let title = csvInfos.title;

        if (!gameData.fixedTimeEvent || !gameData.fixedTimeEvent.eventArr) {
            gameData.fixedTimeEvent = null;
            if (this.gameManager.getCurrentHour() < GeneralKind.GeneralValue.FIXED_EVENT_START_TIME) {
                return;
            }
            // 添加第一个事件
            for (let id in csvInfos) {
                if (id == 'title' || id == '' || id.trim() == '') {
                    continue;
                }
                let info = csvInfos[id];
                if (info[title.is_start] == GeneralKind.EnableState.ENABLED + '') {
                    // if ((currentDay+1) < Number(id)) {
                    //     return;
                    // }
                    let orderIdx = Number(info[title.order_type])-1;
                    if (!gameData.fixedTimeEvent) {
                        gameData.fixedTimeEvent = {
                            eventArr: [],
                            firstTriggerTime: null,
                            arrIdx1: 0,
                            arrIdx2: 0,
                            nextEvent: [],
                            bFinish: false,
                        };
                    }
                    let eventArr = gameData.fixedTimeEvent.eventArr;

                    if (!eventArr[orderIdx]) {
                        eventArr[orderIdx] = [];
                    }
                    let eventItem: FixedTimeEventItem = {
                        id: id
                        , startTime: curTime
                        , delayTime: 0
                    }
                    eventArr[orderIdx].push(eventItem);
                }
            }
            if (gameData.fixedTimeEvent) {
                this.gameManager.writeGameData();
            }
        }

        let fixedTimeEvent = gameData.fixedTimeEvent;
        if (!fixedTimeEvent || fixedTimeEvent.bFinish || !fixedTimeEvent.eventArr) {
            // 事件结束
            return;
        }

        let eventItem: FixedTimeEventItem = null;
        while(true) {
            if (fixedTimeEvent.arrIdx1 >= fixedTimeEvent.eventArr.length) {
                break;
            }
            if (!fixedTimeEvent.eventArr[fixedTimeEvent.arrIdx1] || fixedTimeEvent.eventArr[fixedTimeEvent.arrIdx1].length <= 0) {
                fixedTimeEvent.arrIdx1++;
            } else {
                eventItem = fixedTimeEvent.eventArr[fixedTimeEvent.arrIdx1][fixedTimeEvent.arrIdx2];
                break;
            }
        }
        fixedTimeEvent.eventArr[fixedTimeEvent.arrIdx1][fixedTimeEvent.arrIdx2];

        if (!eventItem) {
            console.error(`数据错误`);
            return;
        }

        if ((eventItem.startTime + eventItem.delayTime) > curTime) {
            // 时间未到
            return;
        }

        this.openEventLayer(
            {
                id: eventItem.id
                , eventCsv: CsvFileKind.CsvFile.FIXED_TIME_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.FIXED_TIME_EVENT_ARR
                , onComplete: ()=> {
                    this.onFixedTimeEventFinish();
                    // fixedTimeEvent.bFinish = true;

                    // let info = csvInfos[fixedTimeEvent.id];
                    // // 下一个事件
                    // let nextId = info[title.next_id];
                    // if (!nextId) {
                    //     this.gameManager.writeGameData();
                    //     return;
                    // }
                    // let infoN = csvInfos[nextId];
                    // if (!infoN) {
                    //     return;
                    // }
                    // let delayTime = Number(nextId) - Number(fixedTimeEvent.id);
                    // infoN
                    // // 添加下一天的事件
                    // let event: DelayTimeEventInfo = {
                    //     id: nextId,
                    //     delayTime: delayTime,
                    //     startTime: currentDay,
                    //     bFinish: false,
                    // }
                    // gameData.fixedTimeEvent.unshift(event);
                    // this.gameManager.writeGameData();
                }
            }
        );
    }

    /**
     * 事件完成回调
     */
    onFixedTimeEventFinish() {
        const c_oneHour = 60 / GeneralKind.GeneralValue.GAME_TIME_JUMP;
        // 每天多少秒
        const c_oneDay = c_oneHour * 24;
        // 当前时间
        let curTime = this.getCurTime();
        // 游戏数据
        let gameData = this.gameManager.getGameData();
        // 事件信息
        let fixedTimeEvent = gameData.fixedTimeEvent;
        // 事件组
        let eventArr = fixedTimeEvent.eventArr;
        // 第一个记录时间
        if (fixedTimeEvent.arrIdx1 == 0 && fixedTimeEvent.arrIdx2 == 0) {
            fixedTimeEvent.firstTriggerTime = curTime;
        }
        let firstTriggerTime = fixedTimeEvent.firstTriggerTime;
        // 表格数据
        let csvName = CsvFileKind.CsvFile.FIXED_TIME_EVENT_ARR;
        let csvInfos = CsvDataManage.instance.getCsvData(csvName);
        let title = csvInfos.title;

        // 下一个数据
        let lastItem = eventArr[fixedTimeEvent.arrIdx1][fixedTimeEvent.arrIdx2];
        fixedTimeEvent.arrIdx2++;
        if (fixedTimeEvent.arrIdx2 >= eventArr[fixedTimeEvent.arrIdx1].length) {
            fixedTimeEvent.arrIdx1++;
            fixedTimeEvent.arrIdx2 = 0;
        } 
        // 取下一个有效数据
        while(!eventArr[fixedTimeEvent.arrIdx1] && fixedTimeEvent.arrIdx1 < eventArr.length) {
            fixedTimeEvent.arrIdx1++;
            fixedTimeEvent.arrIdx2 = 0;
        }
        // 延迟时间
        let next_delay = Number(csvInfos[lastItem.id][title.next_delay]);
        // 事件组是否完成
        if (fixedTimeEvent.arrIdx1 >= eventArr.length) {
            // 完成一组事件
            if (!fixedTimeEvent.nextEvent || fixedTimeEvent.nextEvent.length <= 0) {
                fixedTimeEvent.bFinish = true;
            } else {
                // 开始下一组事件
                gameData.fixedTimeEvent = {
                    eventArr: [],
                    firstTriggerTime: null,
                    arrIdx1: 0,
                    arrIdx2: 0,
                    nextEvent: [],
                    bFinish: false,
                };
                let delayTime = next_delay;
                // 间隔小于1天
                if (Math.floor(curTime / c_oneDay) - Math.floor(firstTriggerTime / c_oneDay) < 1) {
                    delayTime = c_oneDay - (curTime % c_oneDay)
                        + GeneralKind.GeneralValue.FIXED_EVENT_START_TIME * c_oneHour;
                }
                
                let eventArrT = gameData.fixedTimeEvent.eventArr;
                for (let o of fixedTimeEvent.nextEvent) {
                    let info = csvInfos[o];
                    if (!info) {
                        continue;
                    }
                    let orderIdx = Number(info[title.order_type])-1;
                    if (!eventArrT[orderIdx]) {
                        eventArrT[orderIdx] = [];
                    }
                    let eventItem: FixedTimeEventItem = {
                        id: o
                        , startTime: curTime
                        , delayTime: delayTime
                    }
                    eventArrT[orderIdx].push(eventItem);
                }
            }
        } else {
            // 下一个事件
            let eventItem = eventArr[fixedTimeEvent.arrIdx1][fixedTimeEvent.arrIdx2];
            eventItem.startTime = curTime;
            eventItem.delayTime = next_delay;
        }
        this.gameManager.writeGameData();
    }

    openDelayEvent() {
        if (!this.gameManager) {
            return;
        }
        if (this.gameManager.getNodeStr().length >= 1) {
            return;
        }

        let gameData = this.gameManager.getGameData();
        let currentDay = this.gameManager.getCurrentDay();
        let event: DelayTimeEventInfo = null;
        // let idx = 0;
        for (let o of gameData.delayTimeEventList) {
            if (o.bFinish) {
                continue;
            }
            if ((o.startTime + o.delayTime) > currentDay) {
                // 时间未到
                continue;
            }
            event = o;
            break;
        }
        if (!event) {
            return;
        }

        this.openEventLayer(
            {
                id: event.id
                , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY
                , onComplete: ()=> {
                    event.bFinish = true;
                    for (let i=0; i < gameData.delayTimeEventList.length; i++) {
                        if (gameData.delayTimeEventList[i] == event) {
                            gameData.delayTimeEventList.splice(i, 1);
                            break;
                        }
                    }
                    this.gameManager.writeGameData();
                }
            }
        );
    }

    openEvent() {
        this.triggerFixedTimeEvent();
        this.openDelayEvent();
    }

    openEventLayer(data: any) {
        if (this.bOpenEventLayer) {
            return false;
        }
        let onComplete = data.onComplete;
        data.onComplete = ()=> {
            if (onComplete) {
                onComplete();
            }
            this.bOpenEventLayer = false;
        }

        this.bOpenEventLayer = true;
        utilsView.openEventLayer(
            null
            , data
            , UI_Z_INDEX.DIALOG
        );
        return true;
    }

    openRandomEvent() {
        if (this.gameManager.getNodeStr().length >= 1) {
            return;
        }
        
        let currentDay = this.gameManager.getCurrentDay();
        let randomEventCount = this.gameManager.getGameData().randomEventCount;
        if (!randomEventCount[currentDay]) {
            randomEventCount[currentDay] = 0;
        } else {
            if (randomEventCount[currentDay] >= 1) {
                return;
            }
        }
        let randomId = CsvDataManage.instance.getCsvRandomId(CsvFileKind.CsvFile.RANDOM_EVENT_ARR);
        
        let bOpen = this.openEventLayer(
            {
                id: randomId
                , eventCsv: CsvFileKind.CsvFile.RANDOM_EVENT
                , eventArrCsv: CsvFileKind.CsvFile.RANDOM_EVENT_ARR
            }
        );
        if (bOpen) {
            randomEventCount[currentDay]++;
            this.gameManager.writeGameData();
        }
    }

    openUpGradeEvent(id:string){
        this.openEventLayer({id:id,eventCsv:CsvFileKind.CsvFile.UPGRADE_EVENT,eventArrCsv:CsvFileKind.CsvFile.UPGRADE_EVENT_ARR});
    }

}
